import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import MonthStatement from './MonthStatement';

function YearStatement({ year, statements }) {
  return (
    <Stack
      aria-label={`Statements for ${year}`}
      direction="column"
      role="list"
      spacing="16px"
    >
      <Text
        role="heading"
        size="xs"
        weight="medium"
      >
        {year}
      </Text>
      <Stack direction="column">
        {statements.map(({ id, month, last4Digits }) => (
          <MonthStatement
            id={id}
            key={id}
            last4Digits={last4Digits}
            month={month}
            year={year}
          />
        ))}
      </Stack>
    </Stack>
  );
}

YearStatement.propTypes = {
  year: PropTypes.string.isRequired,
  statements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      month: PropTypes.string.isRequired,
      last4Digits: PropTypes.string.isRequired,
      unitAccountId: PropTypes.string
    })
  ).isRequired
};

export default YearStatement;
